(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.register = function(module) {
    return module.service('Core.Services.Routing', ['$state', '$location', '$http', '$window', 'localStorageService', 'Core.Services.Session', exports.Routing]);
  };

  exports.Routing = (function(superClass) {
    extend(Routing, superClass);

    function Routing(state1, location1, http, window, localStorage, session) {
      this.state = state1;
      this.location = location1;
      this.http = http;
      this.window = window;
      this.localStorage = localStorage;
      this.session = session;
      this.goToState = bind(this.goToState, this);
      this.determineDestination = bind(this.determineDestination, this);
      this.findAppByReferrer = bind(this.findAppByReferrer, this);
      void 0;
    }

    Routing.prototype.findAppByReferrer = function(referrer) {
      var domain, domains, environment, environments, i, len;
      if (!referrer) {
        return 'dashboard';
      }
      environments = {
        portal: ['rportal.*', 'portal.*', 'portal.myfarms.*', 'testportal.*'],
        admin: ['radmin.*', 'admin.*', 'admin.myfarms.*', 'testadmin.*'],
        grower: ['rdev.*', 'grower.*', 'localhost.*', 'myfarms.*']
      };
      for (environment in environments) {
        domains = environments[environment];
        for (i = 0, len = domains.length; i < len; i++) {
          domain = domains[i];
          if (referrer.match(new RegExp(domain))) {
            return environment;
          }
        }
      }
      return 'dashboard';
    };

    Routing.prototype.determineDestination = function(stateParams) {
      var location;
      if (stateParams == null) {
        stateParams = {};
      }
      if (stateParams.registration_token) {
        this.http.post('backend/core/grower-registration/auto-link', {
          token: stateParams.registration_token
        });
      }
      if (this.localStorage.get('previous_location') != null) {
        location = this.localStorage.get('previous_location').href;
        this.localStorage.remove('previous_location');
        this.window.location = location;
      }
      return this.http.post('/backend/get-experiences').then((function(_this) {
        return function(response) {
          var branding, count, desiredState, experience, i, len, ref, referrer, referringApp, selectedExperience, userData;
          branding = stateParams.b;
          referrer = stateParams.r;
          referringApp = _this.findAppByReferrer(referrer);
          if (branding) {
            _this.session.set("SelectedCompany-" + referringApp, branding);
            return _this.goToState(referringApp);
          }
          userData = response.data.data;
          if (referringApp && referringApp !== 'dashboard') {
            count = 0;
            selectedExperience = null;
            ref = userData.experiences;
            for (i = 0, len = ref.length; i < len; i++) {
              experience = ref[i];
              if (experience.text.toLowerCase() === referringApp) {
                count++;
                selectedExperience = experience;
              }
            }
            if (count === 1) {
              _this.session.set("SelectedCompany-" + referringApp, selectedExperience.company);
              return _this.goToState(referringApp);
            }
            if (count > 1 && userData.defaultCompany) {
              _this.session.set("SelectedCompany-" + referringApp, userData.defaultCompany);
              return _this.goToState(referringApp);
            }
          }
          if (userData.defaultCompany && userData.defaultDomain) {
            desiredState = userData.defaultDomain.toLowerCase();
            _this.session.set("SelectedCompany-" + desiredState, userData.defaultCompany);
            return _this.goToState(desiredState);
          }
          if (userData.experiences.length === 1) {
            desiredState = userData.experiences[0].text.toLowerCase();
            _this.session.set("SelectedCompany-" + desiredState, userData.experiences[0].company);
            return _this.goToState(desiredState);
          }
          return _this.state.go('dashboard');
        };
      })(this));
    };

    Routing.prototype.goToState = function(state) {
      if (!this.state.includes(state)) {
        return this.state.go(state);
      }
    };

    return Routing;

  })(Service);

}).call(this);
